import { render } from "./GenericInput.vue?vue&type=template&id=8b7e5722&ts=true"
import script from "./GenericInput.vue?vue&type=script&lang=ts"
export * from "./GenericInput.vue?vue&type=script&lang=ts"

import "./GenericInput.vue?vue&type=style&index=0&id=8b7e5722&lang=scss"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__